<template>
    <el-container>
        <el-main>
            <template v-if="infos">
                <el-card shadow="always" class="box-card">
                    <template #header>小程序版本</template>
                    <div class="version-box">
                        <div class="item" v-if="version && version.exp_info">
                            <h3>体验版</h3>
                            <div class="in_2">版本：{{version.exp_info.exp_version}}</div>
                            <div class="in_3">发布时间：{{Utils.formatDate('Y-m-d H:i:s', version.exp_info.exp_time)}}</div>
                            <div class="in_1">版本说明{{version.exp_info.exp_desc}}</div>
                            <div class="in_1" v-if="infos.status == 4">不通过原因：infos.reason</div>
                            <div class="but">
                                <el-button v-if="infos.status == 1" type="primary" @click="onSubmitCx">查询审核状态</el-button>
                                <el-button v-if="infos.status == 2 && version.exp_info.exp_version !== version.release_info.release_version" type="primary" @click="onSubmitFb">发布</el-button>
                            </div>
                        </div>
                        <div class="item fb" v-if="version && version.release_info">
                            <h3>发布版</h3>
                            <div class="in_2">版本：{{version.release_info.release_version}}</div>
                            <div class="in_3">发布时间：{{Utils.formatDate('Y-m-d H:i:s', version.release_info.release_time)}}</div>
                            <div class="in_1">版本说明：{{version.release_info.release_desc}}</div>
                        </div>
                    </div>
                </el-card>
                <div style="height: 20px;"></div>
                <el-card shadow="always" class="box-card" v-if="infos.status == 0 || infos.status == 4">
                    <template #header>小程序审核</template>
                    <el-form :model="post_setting_list" label-position="top">
                        <el-form-item label="小程序版本说明和功能解释">
                            <el-input v-model="post_data.version_desc" />
                            <div class="help-block">小程序当前版本简介</div>
                        </el-form-item>
                        <el-form-item label="小程序页面预览截图">
                            <upload v-model="preview_img.img" v-model:checkedData="preview_img.path" button="上传多张图片" :is-multiple="true" dir="images" />
                            <el-button type="primary" @click="upButton">提交图片到微信素材</el-button>
                            <div class="help-block">最多上传5张图片</div>
                        </el-form-item>
                        <el-form-item label="订单中心path">
                            <el-input disabled v-model="post_data.order_path" />
                        </el-form-item>
                        <el-form-item label="反馈内容" v-if="false">
                            <el-input v-model="post_data.feedback_info" />
                            <div class="help-block">审核不通过，反馈重审</div>
                        </el-form-item>
                        <el-form-item label="小程序页面预览截图" v-if="false">
                            <upload v-model="feedback_stuff.img" v-model:checkedData="feedback_stuff.path" button="上传多张图片" :is-multiple="true" dir="images" />
                            <el-button type="primary" @click="upFeedButton">提交图片到微信素材</el-button>
                            <div class="help-block">最多上传5张图片</div>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="onSubmitSh">提交</el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
                <div style="height: 20px;"></div>
                <el-card shadow="always" class="box-card">
                    <template #header>设置小程序用户隐私保护指引</template>
                    <el-form :model="post_setting_list" label-position="top">
                        <el-form-item label="信息收集方（开发者）的手机号">
                            <el-input v-model="post_setting_list.contact_phone" />
                            <div class="help-block">手机号或邮箱，最少填写一项</div>
                        </el-form-item>
                        <el-form-item label="信息收集方（开发者）的邮箱地址">
                            <el-input v-model="post_setting_list.contact_email" />
                        </el-form-item>
                        <el-form-item label="通知方式">
                            <el-input v-model="post_setting_list.notice_method" />
                            <div class="help-block">如：通过短信的方式</div>
                        </el-form-item>
                        <template v-for="(item, index) in form_privacy" :key="index">
                            <el-form-item :label="'信息收集项：' + item.label">
                                <el-input v-model="item.privacy_text"/>
                                <div class="help-block">填写搜集{{item.label}}的用途，举例：为了<span style="color: #ff0000">绑定系统账号</span>，开发者将在获取你的明示同意后，收集你的微信昵称、头像。</div>
                            </el-form-item>
                        </template>

                        <el-form-item>
                            <el-button type="primary" @click="onSubmitYs">提交</el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
            </template>
        </el-main>
    </el-container>
</template>

<script setup>
    import { getCurrentInstance, defineComponent, ref, provide, reactive, onMounted } from 'vue'
    import Utils from '@/utils/util'
    import Upload from '@/components/ui-upload'

    import { Host } from '@/config/index'
    const { proxy } = getCurrentInstance()
    const query = reactive(proxy.$router.currentRoute.value.query)
    const infos = ref()
    const privacy_info = ref()
    const category = ref()
    const version = ref()
    const getInfo = () => {
        return new Promise((resolve, reject) => {
            proxy.jiu.request(`${Host}agency/shared/wechat/submit`).then((res, rej) => {
                infos.value = res.data.info
                privacy_info.value = res.data.privacy_info
                category.value = res.data.category
                version.value = res.data.version
                resolve(1)
            }).catch((error) => {
                reject(0)
                proxy.jiu.showError(error)
            })
        })
    }
    const post_data = ref({
        preview_info: [],
        feedback_info: '',
        feedback_stuff: [],
        item_list: {},
        version_desc: '',
        order_path: ''
    })
    const preview_img = ref({
        'img': '',
        'path': '',
        'mediaids': []
    })
    const feedback_stuff = ref({
        'img': '',
        'path': '',
        'mediaids': []
    })
    const post_setting_list = ref({
        contact_phone: '',
        contact_email: '',
        notice_method: ''
    })

    const form_privacy = ref([])
    getInfo().then(() => {
        post_data.value.order_path = infos.value.order_path
        post_data.value.feedback_info = infos.value.feedback_info
        post_data.value.version_desc = infos.value.version_desc
        post_data.value.feedback_stuff = infos.value.feedback_stuff ? JSON.parse(infos.value.feedback_stuff) : []
        post_data.value.item_list = infos.value.item_list ? JSON.parse(infos.value.item_list) : []
        post_data.value.preview_info = infos.value.preview_info ? JSON.parse(infos.value.preview_info) : []

        post_setting_list.value.contact_phone = privacy_info.value.owner_setting.contact_phone
        post_setting_list.value.contact_email = privacy_info.value.owner_setting.contact_email
        post_setting_list.value.notice_method = privacy_info.value.owner_setting.notice_method ?? '通过短信的方式'
        privacy_info.value.setting_list.map((item) => {
            for (let i in privacy_info.value.privacy_desc.privacy_desc_list) {
                if (privacy_info.value.privacy_desc.privacy_desc_list[i]['privacy_key'] === item.privacy_key) {
                    let text = item.privacy_text
                    if (item.privacy_key === 'Location' && !text) text = '就近原则匹配客户'
                    if ((item.privacy_key === 'UserInfo' || item.privacy_key === 'PhoneNumber') && !text) text = '绑定系统账号'
                    form_privacy.value.push({
                        privacy_key: item.privacy_key,
                        privacy_text: item.privacy_text,
                        label: privacy_info.value.privacy_desc.privacy_desc_list[i]['privacy_desc']
                    })
                }
            }
        })
    })

    const onSubmitYs = () => {
        let setting_list = []
        form_privacy.value.map((item) => {
            setting_list.push({
                'privacy_key': item.privacy_key,
                'privacy_text': item.privacy_text
            })
        })
        let obj = {
            setting_list: setting_list,
            owner_setting: post_setting_list.value
        }
        proxy.jiu.request(`${Host}agency/shared/wechat/privacy`, { datas: JSON.stringify(obj) }, 'POST').then((res, rej) => {
            proxy.jiu.toast('提交成功，请等待耐心微信审核')
            getInfo()
        }).catch((error) => {
            proxy.jiu.showError(error)
        })
    }

    const upButton = () => {
        proxy.jiu.request(`${Host}agency/shared/wechat/uploadmedia`, { datas: preview_img.value.img, type: 1 }, 'POST').then((res, rej) => {
            for (let i in res.data) {
                preview_img.value.mediaids.push(res.data[i])
            }
            proxy.jiu.toast('图片成功上传到媒体库')
        }).catch((error) => {
            proxy.jiu.showError(error)
        })
    }

    const upFeedButton = () => {
        proxy.jiu.request(`${Host}agency/shared/wechat/uploadmedia`, { datas: feedback_stuff.value.img, type: 2 }, 'POST').then((res, rej) => {
            for (let i in res.data) {
                feedback_stuff.value.mediaids.push(res.data[i])
            }
            proxy.jiu.toast('图片成功上传到媒体库')
        }).catch((error) => {
            proxy.jiu.showError(error)
        })
    }

    const onSubmitSh = () => {
        post_data.value.preview_info = preview_img.value.mediaids
        post_data.value.feedback_stuff = preview_img.value.feedback_stuff

        proxy.jiu.request(`${Host}agency/shared/wechat/submit`, { datas: JSON.stringify(post_data.value) }, 'POST').then((res, rej) => {
            for (let i in res.data) {
                preview_img.value.mediaids.push(res.data[i])
            }
            proxy.jiu.toast(res.data.message)
        }).catch((error) => {
            proxy.jiu.showError(error)
        })
    }

    const onSubmitFb = () => {
        proxy.jiu.request(`${Host}agency/shared/wechat/release`, { datas: JSON.stringify(post_data.value) }, 'POST').then((res, rej) => {
            proxy.jiu.toast('发布成功')
        }).catch((error) => {
            proxy.jiu.showError(error)
        })
    }

    const onSubmitCx = () => {
        proxy.jiu.request(`${Host}agency/shared/wechat/query`, { datas: JSON.stringify(post_data.value) }, 'POST').then((res, rej) => {
            proxy.jiu.toast(res.data)
            getInfo()
        }).catch((error) => {
            proxy.jiu.showError(error)
        })
    }
</script>

<style lang="scss" scoped>
    .version-box {
        display: flex;
        justify-content: space-between;
        .item {
            width: 48%;
            background-color: #ededed;
            padding: 20px;
            line-height: 2;
            border-radius: 20px;
            .but {
                padding-top: 20px;
            }
        }
        .fb {
            background-color: #cde0f8;
        }
    }
</style>
